import CollectionList from "@/js/Shared/Collections/CollectionList";

export {MessageAttachmentsList as default};

/**
* Messages List Entity
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class MessageAttachmentsList extends CollectionList {
  /**
   * Attachments download link
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {String}
   */
  download;

  /**
   * Constructor
   *
   * @public
   *
   * @since 7.0.0
   */
  constructor() {
    super('id');
  }

  deleteAttachmentsContents(){
    this.items.forEach(element => {
      element.contents = null;
    });
  }
}